import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import FounderSection from "../components/FounderSection";
import WhyLongev from "../components/WhyLongev";
import Testimonials from "../components/Testimonials";
import { PILLARS, BRAND } from "../mock";

export default function AboutPage() {
  return (
    <>
      <section className="pt-[120px] lg:pt-[160px] pb-16 lg:pb-20 bg-[var(--lc-cream)]">
        <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
          <div className="max-w-4xl">
            <div className="eyebrow text-[var(--lc-moss)] mb-5">About LONGEV CIRCLE</div>
            <h1 className="font-serif-display text-[clamp(40px,6.5vw,96px)] leading-[1] font-light">
              Built for those who refuse to <span className="italic">slow down.</span>
            </h1>
            <p className="mt-8 max-w-2xl text-[16px] leading-relaxed text-[var(--lc-muted)]">
              {BRAND.name} is {BRAND.location}'s first fully integrated
              Total Body Transformation ecosystem. We combine six pillars of
              elite health — nutrition, strength, endurance, medical, wellness
              and longevity — into one cohesive coaching plan, tailored to your
              personal goals and schedule.
            </p>
          </div>

          <div className="mt-14 lg:mt-20 grid sm:grid-cols-3 gap-5 lg:gap-8">
            {[
              { k: "6", v: "Pillars" },
              { k: "1:1", v: "Personal Coaching" },
              { k: "24h", v: "Quote Turnaround" },
            ].map((s) => (
              <div key={s.v} className="border-t border-[var(--lc-ink)] pt-5">
                <div className="font-serif-display text-[44px] lg:text-[56px] leading-none">{s.k}</div>
                <div className="mt-2 eyebrow text-[var(--lc-muted)]">{s.v}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FounderSection />
      <WhyLongev />

      {/* Pillars summary */}
      <section className="bg-[var(--lc-cream)] py-20 lg:py-24">
        <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
          <h2 className="font-serif-display text-[clamp(32px,4.5vw,56px)] leading-[1] font-light max-w-2xl">
            All <span className="italic">six pillars</span>, integrated.
          </h2>
          <div className="mt-10 divide-y divide-[var(--lc-line)] border-y border-[var(--lc-line)]">
            {PILLARS.map((p) => {
              const Icon = p.icon;
              return (
                <Link
                  key={p.id}
                  to={`/build?pillar=${p.id}`}
                  className="group flex items-center gap-6 py-6 lg:py-8 hover:bg-[var(--lc-cream-soft)] transition-colors px-3 -mx-3"
                >
                  <span className="font-serif-display text-2xl text-[var(--lc-muted)] w-12">{p.number}</span>
                  <Icon className="h-5 w-5 text-[var(--lc-moss)] shrink-0" />
                  <div className="flex-1 min-w-0">
                    <div className="font-serif-display text-2xl lg:text-3xl leading-tight">{p.name}</div>
                    <div className="text-sm text-[var(--lc-muted)] mt-1 max-w-2xl">{p.description}</div>
                  </div>
                  <ArrowUpRight className="h-5 w-5 text-[var(--lc-muted)] group-hover:text-[var(--lc-ink)] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all shrink-0" />
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      <Testimonials />
    </>
  );
}
